<!-- 用户编辑弹窗 -->
<template>
  <a-modal
    :width="680"
    :visible="visible"
    :confirm-loading="loading"
    :title="isUpdate ? '修改卡面管理' : '新建卡面管理'"
    :body-style="{ paddingBottom: '8px' }"
    @update:visible="updateVisible"
    @ok="save"
  >
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ md: { span: 7 }, sm: { span: 24 } }"
      :wrapper-col="{ md: { span: 17 }, sm: { span: 24 } }"
    >
      <a-row :gutter="16">
        <a-col :md="20" :sm="24" :xs="24">
          <a-form-item label="优惠券名称:" name="name">
            <a-input
              v-model:value="form.name"
              placeholder="请输入优惠券名称"
              allow-clear
            >
            </a-input>
          </a-form-item>
          <a-form-item label="最低消费:" name="minPrice">
            <a-input
              v-model:value="form.minPrice"
              placeholder="请输入最低消费"
              allow-clear
            >
            <template #addonBefore>满</template>
            <template #addonAfter>元</template>
            </a-input>
          </a-form-item>
          <a-form-item label="优惠券类型:" name="couponType">
            <a-radio-group
              v-model:value="form.couponType"
              @change="couponTypeChange"
            >
              <a-radio :value="10">满减券</a-radio>
              <a-radio :value="20">折扣券</a-radio>
            </a-radio-group>
          </a-form-item>
          <div v-if="form.couponType === 10">
            <a-form-item label="减免金额:" name="reducePrice">
              <a-input
                v-model:value="form.reducePrice"
                placeholder="请输入减免金额"
                allow-clear
              >
                <template #addonAfter>元</template>
              </a-input>
            </a-form-item>
          </div>
          <div v-if="form.couponType === 20">
            <a-form-item label="折扣率:" name="discount">
              <a-input
                v-model:value="form.discount"
                placeholder="请输入折扣率"
                allow-clear
              >
                <template #addonAfter>%</template>
              </a-input>
            </a-form-item>
          </div>
          <a-form-item label="到期类型:" name="expireType">
            <a-radio-group
              v-model:value="form.expireType"
              @change="expireTypeChange"
            >
              <a-radio :value="10">领取后生效</a-radio>
              <a-radio :value="20">固定时间</a-radio>
            </a-radio-group>
          </a-form-item>
          <div v-if="form.expireType === 10">
            <a-form-item label="有效天数:" name="expireDay">
              <a-input
                v-model:value="form.expireDay"
                placeholder="请输入有效天数"
                allow-clear
              >
                <template #addonAfter>天</template>
              </a-input>
            </a-form-item>
          </div>
          <div v-if="form.expireType === 20">
            <!-- <a-form-item label="固定时间:" name="couponTime">
              <a-range-picker
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                v-model:value="form.couponTime"
                @change="expireTimeChange"
              />
            </a-form-item> -->
            <a-form-item label="开始时间:" name="startTime">
            <a-date-picker
                v-model:value="form.startTime"
                allowClear
                value-format="YYYY-MM-DD"
                class="ud-fluid"
              >
              </a-date-picker>
              </a-form-item>
              <a-form-item label="结束时间:" name="endTime">
            <a-date-picker
                v-model:value="form.endTime"
                value-format="YYYY-MM-DD"
                class="ud-fluid"
              >
              </a-date-picker>
              </a-form-item>
          </div>
          <a-form-item label="适用范围:" name="applyRange">
            <a-radio-group
              v-model:value="form.applyRange"
              @change="applyRangeChange"
            >
              <a-radio :value="10">全部商品</a-radio>
              <a-radio :value="20">指定商品</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="状态:" name="status">
            <a-radio-group v-model:value="form.status" @change="statusChange">
              <a-radio :value="1">显示</a-radio>
              <a-radio :value="0">隐藏</a-radio>
            </a-radio-group>
          </a-form-item>
          <!-- <a-form-item label="等级权益:" name="equity">
            <a-input-number
              v-model:value="form.name"
              placeholder="请输入等级权益"
              allow-clear
            >
            </a-input-number>
            <div style="color: #999999">折扣率范围0.0-9.9，例: 9.8代表98折，0代表不折扣</div>
          </a-form-item> -->
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import setting from '@/config/setting'
// import { PlusOutlined } from '@ant-design/icons-vue'
// import * as pointsCategoryApi from '@/api/jyyw/pointsCategory'
import * as corpCouponApi from '@/api/corp/corpCoupon'
// import moment from 'moment'
import * as dictDataApi from '@/api/sys/dictData'
// function getBase64(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader()
//     reader.readAsDataURL(file)
//     reader.onload = () => resolve(reader.result)
//     reader.onerror = (error) => reject(error)
//   })
// }
export default {
  name: 'corpCouponEdit',
  components: {
    // PlusOutlined
  },
  emits: ['done', 'update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 修改回显的数据
    data: Object,
    couponId: Number
  },
  data() {
    return {
      // 表单数据
      form: Object.assign({}, this.data),
      imgList: [],
      logoList: [],
      uploadUrl: setting.uploadUrl,
      // 表单验证规则
      rules: {
        name: [
          {
            required: true,
            message: '请输入等级名称',
            type: 'string',
            trigger: 'blur'
          }
        ],
        weight: [
          {
            required: true,
            message: '请选择等级权重',
            type: 'number',
            trigger: 'blur'
          }
        ],
        equity: [
          {
            required: true,
            message: '请输入等级权益',
            type: 'string',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            type: 'number',
            trigger: 'blur'
          }
        ]
      },
      // 提交状态
      loading: false,
      // 是否是修改
      isUpdate: false,
      previewVisible: false,
      previewImage: '',
      // 状态字典项
      stateDict: [],
      weightList: []
    }
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({}, this.data)
        // if (this.form.startTime && this.form.endTime) {
        //   console.log('startTime211', this.form.startTime)
        //   this.form.couponTime = moment(this.form.startTime).format('YYYY-MM-DD') + '-' + moment(this.form.endTime).format('YYYY-MM-DD')
        //   console.log('couponTime213', this.form.couponTime)
        // }
        this.isUpdate = true
      } else {
        this.form = {}
        this.isUpdate = false
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    }
  },
  mounted() {
    this.queryDataStates()
  },
  methods: {
    couponTypeChange(e) {
      this.form.couponType = e.target.value
    },
    expireTypeChange(e) {
      this.form.expireType = e.target.value
    },
    expireTimeChange(e, value) {
      console.log('expireTimeChange', e)
      console.log('expireTimeChange2', value)
      this.form.startTime = value[0]
      this.form.endTime = value[1]

      console.log('startTime', this.form.startTime)
      console.log('endTime', this.form.endTime)
    },
    applyRangeChange(e) {
      this.form.applRange = e.target.value
    },
    statusChange(e) {
      this.form.status = e.target.value
    },
    /* 保存编辑 */
    save() {
      if(!this.isUpdate){
        this.form.corpId = this.getCorpId()
      }
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true
          console.log('this.form168', this.form)
          if (this.couponId) {
            this.form.couponId = this.couponId
          }
          if (this.form.couponType === 10 && this.form.discount) {
            this.form.discount = 0
          }
          if (this.form.couponType === 20 && this.form.reducePrice) {
            this.form.reducePrice = 0
          }
          console.log('expireType288', this.form.expireType)
          console.log('289', this.form.endTime)
          console.log('290', typeof this.form.endTime)
          if (this.form.expireType === 10 && this.form.endTime) {
            this.form.startTime = ' '
            this.form.endTime = ' '
            this.form.couponTime = ' '
            console.log('284', this.form.startTime)
            console.log('285', this.form.endTime)
            console.log('286', this.form.couponTime)
          }
          if (this.form.expireType === 20 && this.form.expireDay) {
            this.form.expireDay = 0
          }
          corpCouponApi
            .save(this.form, this.isUpdate)
            .then((res) => {
              this.loading = false
              if (res.code === 0) {
                this.$message.success(res.msg)
                if (!this.isUpdate) {
                  this.form = {}
                }
                this.updateVisible(false)
                this.$emit('done')
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch((e) => {
              this.loading = false
              this.$message.error(e.message)
            })
        })
        .catch(() => {})
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    },
    // 等级权重字典项
    queryDataStates() {
      dictDataApi
        .querydictdata('gradeWeight')
        .then((res) => {
          if (res.code === 0) {
            this.weightList = res.data
            this.weightList.map((item) => {
              item.dictDataCode = parseInt(item.dictDataCode)
              console.log('item.dictDataCode', typeof item.dictDataCode)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.colorStyle {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  .colorStyle-sub {
    width: 35px;
    height: 35px;
    border-radius: 6px;
    // position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    // background: #40a9ff;
    .icon {
      position: absolute;
      color: #fff;
    }
  }
}
</style>
